import React, { FC, useRef } from 'react';
import { Animated } from 'react-native';
import { Headroom } from '@components';
import { useRecoilState, useRecoilValue } from 'recoil';

import { useNodeHandle } from '@hooks';
import { navigationService } from '@services';
import { PlaylistItem, vodPlaylistState } from '@store';
import { VideoData } from '@types';

import { OnDemandVideoControls } from './OnDemandVideoControls/OnDemandVideoControls';
import { PlayListLayout } from './PlayListLayout/PlayListLayout';
import { LAYOUT_OFFSET } from './constants';

type VODVideoControlsProps = {
  controlsOnRef: (reference: { hidePlayList: (() => void) | null; focusPlayButton: () => void }) => void;
  data: VideoData;
  setIsPlaylistFocused: (val: boolean) => void;
  showControls: () => void;
  onControl: (control: string, value?: number) => void;
  nextFocusUp?: null;
  onFocus?: unknown;
};

export const VODVideoControls: FC<VODVideoControlsProps> = ({
  controlsOnRef,
  data,
  setIsPlaylistFocused,
  showControls,
  onControl,
  nextFocusUp = null,
  onFocus,
}) => {
  const { playlist, title, ignoreCurrent, currentID } = useRecoilValue(vodPlaylistState);
  const [currentVODPlaylistState, setVODPLaylist] = useRecoilState(vodPlaylistState);

  let newPlaylist: PlaylistItem[] = [];

  const layoutOffset = useRef(new Animated.Value(LAYOUT_OFFSET)).current;
  const playButtonReference = useRef<number | null>(null);
  const playPauseHandle = useNodeHandle(playButtonReference);

  const playlistReference = useRef<number | null>(null);
  const playlistHandle = useNodeHandle(playlistReference);

  const hidePlaylist = !playlist || playlist.length === 0;

  const onItemPress = (_id: string) => {
    navigationService.setParameters({ videoID: _id });
    setVODPLaylist({
      ...currentVODPlaylistState,
      currentID: _id,
    });
  };

  // Removing the current item for playlist rail.
  newPlaylist = ignoreCurrent && !hidePlaylist ? playlist.filter(item => item._id !== currentID) : [];

  return (
    <Headroom
      duration={350}
      headerComponent={
        <OnDemandVideoControls
          data={data}
          nextFocusDown={hidePlaylist ? null : playlistHandle}
          nextFocusUp={nextFocusUp}
          playButtonReference={playButtonReference}
          playPauseHandle={playPauseHandle}
          showControls={showControls}
          onControl={onControl}
          onRef={controlsOnRef}
          onFocus={null}
        />
      }
      headerTestID={'vodControlsWrapper'}
      layoutComponent={
        <PlayListLayout
          nextFocusUp={playPauseHandle}
          onFocus={onFocus}
          onLayoutFocus
          playlistReference={playlistReference}
          setIsPlaylistFocused={setIsPlaylistFocused}
          playlist={newPlaylist}
          title={title}
          onPress={onItemPress}
        />
      }
      layoutOffset={layoutOffset}
      layoutValue={LAYOUT_OFFSET}
    />
  );
};
